import React from "react"
import { Icon } from "@/components/Icon"
import { useStyles } from "@/components/CampaignActionCardSelect/SelectableCampaignActionCard/styles"
import { Flex } from "@mantine/core"

interface SelectableCampaignActionCardProps {
    title: string
    description: string
    icon: string
    iconFamily?: string
    onClick: () => void
    isSelected?: boolean
    isDisabled?: boolean
    orderSelected?: number
    name: string
}

export const SelectableCampaignActionCard = ({
    isSelected = false,
    isDisabled = false,
    title,
    description,
    icon,
    iconFamily = "far",
    onClick,
    orderSelected,
    name,
}: SelectableCampaignActionCardProps) => {
    const { classes } = useStyles({ isSelected, isDisabled })

    return (
        <Flex className={classes.container} data-cy={`campaign-card-${name}`} onClick={onClick}>
            <div className={classes.icon}>
                {isSelected ? (
                    <p className={classes.order}>{orderSelected}</p>
                ) : (
                    <Icon icon={icon} iconFamily={iconFamily} className={classes.svg} />
                )}
            </div>
            <p className={classes.title}>{title}</p>
            <p className={classes.description}>{description}</p>
        </Flex>
    )
}
